export enum MediaType {
  none = "none",
  image = "image",
  video = "video",
  text = "text",
}
